import { Transition } from '@headlessui/react';
import { Fragment, useContext } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { ControlContext } from 'provider/ControlProvider';
import Background from 'assets/img/stroypanel.jpg';
import StoryList from 'assets/data/storylist.json';

export default function MyModal() {
  const { content, showModal, setShowModal } = useContext(ControlContext);

  function closeModal() {
    setShowModal(0);
  }
  return (
    <Transition
      appear
      show={showModal === 5}
      as={Fragment}
      enter='transition-opacity duration-300'
      enterFrom='opacity-0'
      enterTo='opacity-100'
      leave='transition-opacity duration-150'
      leaveFrom='opacity-100'
      leaveTo='opacity-0'
    >
      <div
        className='w-full md:w-96 absolute border-t-12 border-l-0 border-r-0 md:border-l-12 md:border-r-12 border-b-0 md:border-b-12 border-opacity-80 border-yellow-900 rounded-t-3xl rounded-b-none md:rounded-b-3xl text-lg bottom-0 md:top-28 left-0 md:left-12 h-1/3 md:h-5/6 p-5 overflow-hidden shadow-lg drop-shadow-lg stroy-panel bg-cover bg-no-repeat bg-center'
        style={{ backgroundImage: `url(${Background})` }}
      >
        <div className='flex justify-between items-center'>
          <h1 className='text-zinc-800 text-4xl'>
            {StoryList[content.index].title}
          </h1>
          <button onClick={() => closeModal()}>
            <XMarkIcon className='w-8' />
          </button>
        </div>
        <Scrollbars className='w-full h-full'>
          <div
            dangerouslySetInnerHTML={{ __html: StoryList[content.index].story }}
          />
          <p className='h-10'></p>
        </Scrollbars>
      </div>
    </Transition>
  );
}
